import Action from "../actions"

export function fileBrowserReducer(state = {isShowing: false, fileList: []}, action) {
    if (action.type === Action.SHOW_FILE_BROWSER) {
        return action.data
    }
    return state;
}
